var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Prop } from 'vue-property-decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
import { PageService } from '~/utils/page.service';
var TelWater = /** @class */ (function (_super) {
    __extends(TelWater, _super);
    function TelWater() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            caseId: '',
            relationship: '',
            targetName: '',
            targetPhone: '',
            phoneStatus: '',
        };
        _this.dataSet = [];
        return _this;
    }
    // 刷新数据
    TelWater.prototype.refreshData = function () {
        var _this = this;
        this.searchModel.caseId = this.caseId;
        this.caseOperatorPageService
            .findCaseTelRecord(this.searchModel, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], TelWater.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(PageService)
    ], TelWater.prototype, "pageService", void 0);
    __decorate([
        Prop({ required: true })
    ], TelWater.prototype, "caseId", void 0);
    TelWater = __decorate([
        Component({
            components: {},
        })
    ], TelWater);
    return TelWater;
}(Vue));
export default TelWater;
